/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  pricechart whitelist
 */

import {
  CITY_NAME_CHANGED,
  CLEAR_CITY_NAME,
  CLEAR_HOOD_NAME,
  HOOD_NAME_CHANGED,
} from '../../currentSearch/modules/location/constants'
import * as detailConstants from '../constants/detail'
import * as localeConstants from '../constants/locale'
import type { ActionTypes } from './types'

export const whitelist = [
  CITY_NAME_CHANGED,
  CLEAR_CITY_NAME,
  CLEAR_HOOD_NAME,
  HOOD_NAME_CHANGED,
  ...Object.values(localeConstants),
  ...Object.values(detailConstants),
  // This satisfies makes sure that everything in the whitelist is also used in the reducer
] as const satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<ActionTypes['type'], (typeof whitelist)[number]>
false && (shouldBeEmpty satisfies never)
